import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

// Local store sync only — persistence happens through the dedicated test-stream
// PATCH endpoint, so this action must not be matched by any save middleware.
const setWorkingSessionTestStreamReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<{ sessionUuid: string; testStream: boolean }>) => {
    const { sessionUuid, testStream } = action.payload;

    if (state.workingSession?.uuid === sessionUuid) {
      state.workingSession.streaming_options = {
        ...state.workingSession.streaming_options,
        test_stream: testStream,
      };
    }

    if (state.workingProject?.sessions) {
      state.workingProject.sessions = state.workingProject.sessions.map((session) => {
        if (session.uuid === sessionUuid) {
          return {
            ...session,
            streaming_options: {
              ...session.streaming_options,
              test_stream: testStream,
            },
          };
        }
        return session;
      });
    }
  });
};

export default setWorkingSessionTestStreamReducer;
